/**
 * @author lifei
 * 功能：加密解密
 */
import crypto from 'crypto-js'
import { Base } from '../base'

export class Encryption extends Base {
  constructor() {
    super()
  }

  static {
    Base.register(this)
  }

  private get mode() {
    return crypto.mode.ECB
  }

  private get Utf8() {
    return crypto.enc.Utf8
  }

  /**
   * 功能：加密策略
   */
  private get pad() {
    return crypto.pad.Pkcs7
  }

  /**
   * 功能：DES 加密
   */
  public DESEncrypt = (word: string, keyStr?: string): string => {
    // 密钥设置默认值，有传入则以传入的为准
    keyStr = keyStr || 'admin'
    const { mode, Utf8, pad } = this
    const key = Utf8.parse(keyStr)
    const srcs = Utf8.parse(word)
    return crypto.DES.encrypt(srcs, key, { mode, pad }).toString()
  }

  /**
   * 功能： DES 解密
   */
  public DESDecrypt = (word: string, keyStr?: string): string => {
    keyStr = keyStr || 'admin'
    const { mode, Utf8, pad } = this
    const key = Utf8.parse(keyStr)
    const decrypt = crypto.DES.decrypt(word, key, { mode, pad })
    return Utf8.stringify(decrypt).toString()
  }

  /**
   * 功能：MD5 加密
   */
  public MD5 = (word: string): string => crypto.MD5(word).toString()

  /**
   * 功能：base64 加密
   */
  public base64Encrypt = () => {}

  /**
   * 功能：base64 解密
   */
  public base64Decrypt = () => {}

  /**
   * 功能：自定义加密规则处理
   */
  private rule = (): string[] => {
    // 使用当前登陆者姓名等个人信息，加密密码，根据个人信息长度采取不同的替换算法，确保不同的用户加入的算法不一致，没有规律。
    // 存储使用 base64，读取反解析 base64。仅避免记住密码导致密码泄露的而增强的安全处理。
    // 后期建议服务端提供，记住密码，自动登录接口，不在前端处理。
    return []
  }

  public mixPwd = (str: string) => {}

  /**
   * 功能：获取原始密码
   */
  public getRealPwd = (): TCommon.OrUndef<string> => ''

  /**
   * 功能：获取混淆的密码
   */
  public getMixPwd = (): string | null => ''
}

export const encryption = new Encryption()
